import React from 'react';

const Overview = () => {
  const programs = [
    {
      name: "Program Utama",
      description: "Koordinasi keseluruhan dan manajemen proyek digitalisasi",
      icon: "fas fa-cog",
      color: "from-blue-500 to-blue-600",
      activities: [
        "Kick-off Tim Digitalisasi",
        "Setup MDM & LMS",
        "Pengadaan iPad",
        "Pelatihan Guru & Pengasuh",
        "Launching Sistem Digital"
      ]
    },
    {
      name: "Program Pendidikan",
      description: "Fokus pada transformasi pembelajaran dan kurikulum digital",
      icon: "fas fa-graduation-cap",
      color: "from-green-500 to-green-600",
      activities: [
        "Workshop RPP Digital",
        "Integrasi LMS",
        "Uji Coba Pembelajaran",
        "Assessment Digital",
        "Evaluasi Mutu"
      ]
    },
    {
      name: "Program Pengasuhan",
      description: "Integrasi sistem digital dalam kehidupan asrama",
      icon: "fas fa-home",
      color: "from-purple-500 to-purple-600",
      activities: [
        "SOP iPad di Asrama",
        "Sistem Absensi Digital",
        "Monitoring Ibadah",
        "Pelaporan ke Wali",
        "Edukasi Adab Digital"
      ]
    },
    {
      name: "Program QA/Balitbangwas",
      description: "Quality assurance dan pengembangan sistem",
      icon: "fas fa-shield-alt",
      color: "from-orange-500 to-orange-600",
      activities: [
        "Audit Infrastruktur",
        "Supervisi Implementasi",
        "Evaluasi Pilot Project",
        "Laporan Mutu",
        "Rekomendasi Perbaikan"
      ]
    },
    {
      name: "Program Media",
      description: "Publikasi, sosialisasi, dan komunikasi program",
      icon: "fas fa-bullhorn",
      color: "from-pink-500 to-pink-600",
      activities: [
        "Sosialisasi Program",
        "Publikasi Berita",
        "Tutorial LMS",
        "Video Edukasi",
        "Liputan Kegiatan"
      ]
    }
  ];

  const phases = [
    {
      name: "Fase Persiapan",
      period: "Agustus - September 2025",
      description: "Kick-off, sosialisasi, dan persiapan infrastruktur",
      icon: "fas fa-rocket",
      color: "bg-blue-500",
      activities: [
        "Pembentukan tim digitalisasi",
        "Sosialisasi kepada stakeholder",
        "Audit infrastruktur IT",
        "Distribusi iPad guru & pengasuh"
      ]
    },
    {
      name: "Fase Pengembangan",
      period: "Oktober - November 2025",
      description: "Setup sistem dan pengembangan konten",
      icon: "fas fa-tools",
      color: "bg-green-500",
      activities: [
        "Setup MDM & LMS",
        "Perancangan akun dan kelas",
        "Penyusunan SOP",
        "Workshop RPP Digital"
      ]
    },
    {
      name: "Fase Pilot",
      period: "Desember 2025 - Februari 2026",
      description: "Uji coba terbatas dengan kelas pilot",
      icon: "fas fa-flask",
      color: "bg-purple-500",
      activities: [
        "Distribusi iPad siswa pilot",
        "Pelatihan intensif",
        "Simulasi pembelajaran",
        "Evaluasi awal"
      ]
    },
    {
      name: "Fase Evaluasi",
      period: "Maret 2026",
      description: "Evaluasi menyeluruh hasil pilot project",
      icon: "fas fa-search",
      color: "bg-orange-500",
      activities: [
        "Analisis hasil pilot",
        "Identifikasi masalah",
        "Perbaikan sistem",
        "Rekomendasi pengembangan"
      ]
    },
    {
      name: "Fase Implementasi",
      period: "April - Mei 2026",
      description: "Implementasi penuh ke seluruh unit",
      icon: "fas fa-expand-arrows-alt",
      color: "bg-red-500",
      activities: [
        "Distribusi iPad batch akhir",
        "Setup sistem penuh",
        "Simulasi menyeluruh",
        "Finalisasi konten"
      ]
    },
    {
      name: "Fase Finalisasi",
      period: "Juni - Juli 2026",
      description: "Penyelesaian dan launching resmi",
      icon: "fas fa-flag-checkered",
      color: "bg-indigo-500",
      activities: [
        "Audit keamanan final",
        "Finalisasi SOP",
        "Launching resmi",
        "Dokumentasi lengkap"
      ]
    }
  ];

  const targets = [
    {
      category: "Teknologi",
      target: "100% guru, pengasuh, dan siswa menggunakan iPad",
      icon: "fas fa-tablet-alt",
      color: "text-blue-600",
      bgColor: "bg-blue-50"
    },
    {
      category: "Sistem",
      target: "MDM mengelola semua perangkat secara terpusat",
      icon: "fas fa-server",
      color: "text-green-600",
      bgColor: "bg-green-50"
    },
    {
      category: "Platform",
      target: "LMS sebagai platform utama pembelajaran",
      icon: "fas fa-graduation-cap",
      color: "text-purple-600",
      bgColor: "bg-purple-50"
    },
    {
      category: "Integrasi",
      target: "Semua proses belajar & pengasuhan terintegrasi",
      icon: "fas fa-link",
      color: "text-orange-600",
      bgColor: "bg-orange-50"
    }
  ];

  return (
    <div className="min-h-screen py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Overview Program Digitalisasi
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Gambaran menyeluruh tentang struktur, fase, dan target program transformasi digital Al Wafi
          </p>
        </div>

        {/* Program Structure */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Struktur Program</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {programs.map((program, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden">
                <div className={`h-2 bg-gradient-to-r ${program.color}`}></div>
                <div className="p-6">
                  <div className="flex items-center mb-4">
                    <div className={`w-12 h-12 bg-gradient-to-r ${program.color} rounded-lg flex items-center justify-center mr-4`}>
                      <i className={`${program.icon} text-white text-lg`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-800">{program.name}</h3>
                  </div>
                  <p className="text-gray-600 mb-4">{program.description}</p>
                  <div className="space-y-2">
                    <h4 className="font-semibold text-gray-700 text-sm">Aktivitas Utama:</h4>
                    <ul className="space-y-1">
                      {program.activities.map((activity, actIndex) => (
                        <li key={actIndex} className="text-sm text-gray-600 flex items-center">
                          <i className="fas fa-check-circle text-green-500 mr-2 text-xs"></i>
                          {activity}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Implementation Phases */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Fase Implementasi</h2>
          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-blue-500 to-indigo-500 rounded-full hidden lg:block"></div>
            
            <div className="space-y-8">
              {phases.map((phase, index) => (
                <div key={index} className={`flex items-center ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} flex-col`}>
                  {/* Timeline Marker */}
                  <div className="absolute left-1/2 transform -translate-x-1/2 w-6 h-6 bg-white border-4 border-blue-500 rounded-full shadow-lg z-10 hidden lg:block"></div>
                  
                  {/* Content */}
                  <div className={`w-full lg:w-5/12 ${index % 2 === 0 ? 'lg:pr-8' : 'lg:pl-8'}`}>
                    <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 p-6">
                      <div className="flex items-center mb-4">
                        <div className={`w-12 h-12 ${phase.color} rounded-lg flex items-center justify-center mr-4`}>
                          <i className={`${phase.icon} text-white text-lg`}></i>
                        </div>
                        <div>
                          <h3 className="text-xl font-bold text-gray-800">{phase.name}</h3>
                          <p className="text-sm text-gray-500">{phase.period}</p>
                        </div>
                      </div>
                      <p className="text-gray-600 mb-4">{phase.description}</p>
                      <div className="space-y-2">
                        {phase.activities.map((activity, actIndex) => (
                          <div key={actIndex} className="flex items-center text-sm text-gray-600">
                            <i className="fas fa-arrow-right text-blue-500 mr-2 text-xs"></i>
                            {activity}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Target Outcomes */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Target Akhir Program</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {targets.map((target, index) => (
              <div key={index} className={`${target.bgColor} rounded-xl p-6 border-l-4 border-current ${target.color} hover:shadow-lg transition-all duration-300`}>
                <div className="flex items-start space-x-4">
                  <div className={`w-12 h-12 ${target.bgColor} rounded-lg flex items-center justify-center border-2 border-current ${target.color}`}>
                    <i className={`${target.icon} ${target.color} text-lg`}></i>
                  </div>
                  <div>
                    <h3 className={`text-lg font-bold ${target.color} mb-2`}>{target.category}</h3>
                    <p className="text-gray-700">{target.target}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Key Metrics */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white">
            <h2 className="text-3xl font-bold text-center mb-8">Metrik Utama Program</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">11</div>
                <div className="text-blue-100">Bulan</div>
                <div className="text-sm text-blue-200">Durasi Program</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">5</div>
                <div className="text-blue-100">Program</div>
                <div className="text-sm text-blue-200">Divisi Utama</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">6</div>
                <div className="text-blue-100">Fase</div>
                <div className="text-sm text-blue-200">Tahap Implementasi</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">100%</div>
                <div className="text-blue-100">Digital</div>
                <div className="text-sm text-blue-200">Tingkat Integrasi</div>
              </div>
            </div>
          </div>
        </section>

        {/* Success Factors */}
        <section>
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Faktor Kunci Kesuksesan</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-xl shadow-lg p-6 text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-users text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Kolaborasi Tim</h3>
              <p className="text-gray-600">
                Kerja sama yang solid antara semua program untuk mencapai tujuan bersama
              </p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-graduation-cap text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Pelatihan Berkelanjutan</h3>
              <p className="text-gray-600">
                Program pelatihan yang komprehensif untuk semua pengguna sistem
              </p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-chart-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Monitoring & Evaluasi</h3>
              <p className="text-gray-600">
                Sistem monitoring yang ketat untuk memastikan kualitas implementasi
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Overview;
